import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


interface CardSkeletonProps {
  cards: number;
}

const CheckoutSkeleton = ({ cards }: CardSkeletonProps) => {
  return (
    <>
      <div className="ckeletonCheckout">
        <div className="">
            <div className="flex justify-between skeleton skeleton_content">
              <div className=" content_1"></div>
              <div className=" content_2"></div>
            </div>
            <div className="skeleton skeleton_header "></div>
            <div className="skeleton skeleton_header "></div>

            <div className="flex justify-between skeleton skeleton_content">
              <div className="content_1"></div>
              <div className="content_2"></div>
            </div>
           
        </div>
      </div>
    </>
  );
};

export default CheckoutSkeleton;








